import React from 'react';
import { Box } from '@material-ui/core';
import { TemplateType, TemplateConfig } from './types';
import { VerticalLinkList } from './templates/VerticalLinkList';
import { MultiColumnLinks } from './templates/MultiColumnLinks';
import { ImageCardGrid } from './templates/ImageCardGrid';
import { RichArticleCards } from './templates/RichArticleCards';
import { ImageCarousel } from './templates/ImageCarousel';
import { SidebarLinkBox } from './templates/SidebarLinkBox';
import { SidebarCardStack } from './templates/SidebarCardStack';
import { InlineReadingCallout } from './templates/InlineReadingCallout';
import { ContextualLinkBox } from './templates/ContextualLinkBox';
import { RelatedSearches } from './templates/RelatedSearches';
import styles from './styles/templateConfigurator.module.css';

export interface PreviewLink {
  title: string;
  url: string;
  description?: string;
  image?: string;
  anchorText?: string;
  category?: string;
  readingTime?: string;
  publishDate?: string;
  author?: string;
  excerpt?: string;
  videoThumbnail?: string;
  videoDuration?: string;
  channelName?: string;
  viewCount?: string;
  updatedDate?: string;
}

interface TemplatePreviewProps {
  template: TemplateType;
  config: TemplateConfig;
  links: PreviewLink[];
  compact?: boolean;
}

const templateComponents: Partial<Record<TemplateType, React.FC<any>>> = {
  'vertical-link-list': VerticalLinkList,
  'multi-column-links': MultiColumnLinks,
  'image-card-grid': ImageCardGrid,
  'rich-article-cards': RichArticleCards,
  'image-carousel': ImageCarousel,
  'sidebar-link-box': SidebarLinkBox,
  'sidebar-card-stack': SidebarCardStack,
  'inline-reading-callout': InlineReadingCallout,
  'contextual-link-box': ContextualLinkBox,
  'related-searches': RelatedSearches,
  // 'related-videos-carousel' is handled by the new templateRegistry system
};

export const TemplatePreview: React.FC<TemplatePreviewProps> = ({ template, config, links, compact = false }) => {
  const TemplateComponent = templateComponents[template];

  if (!TemplateComponent) {
    return <Box>Unknown template type</Box>;
  }

  return (
    <Box className={compact ? styles.compactPreview : styles.fullPreview}>
      <TemplateComponent config={config} links={links} compact={compact} />
    </Box>
  );
};

export default TemplatePreview;
